module.exports = __webpack_public_path__ + "static/agrihub_logo-2bbf33e6b9087a3f53530dcb3453bd8a.png";